import React, { useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Autocomplete, Button, Card, CircularProgress, FormControl, Grid, InputLabel, List, ListItem, MenuItem, Select, TextField, Typography } from '@mui/material';
import apiService from '../../../utlis/apiService';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useUser } from '../../../context/userContext';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import { apiUrl } from '../../../config';
import { generateYearRange, getPaymentMethod } from '../../../utlis/commonFunction';

export default function FeeReceivedReport() {
    const currentDate = new Date();
    const oneMonthAgo = new Date(currentDate);
    oneMonthAgo.setMonth(currentDate.getMonth() - 1);

    const [data, setData] = useState([]);
    const [branches, setBranches] = useState([]);
    const [totalResults, setTotalResults] = useState(0);
    const [grandTotalPaidAmount, setGrandTotalPaidAmount] = useState(0);

    const [filterData, setFilterData] = useState({
        name: '',
        branch: '',
        year: '',
        paymentMethod: '',
        paymentDateFrom: oneMonthAgo,
        paymentDateTo: currentDate,
    });

    const [paginationModel, setPaginationModel] = useState({
        pageSize: 50,
        page: 0,
    });
    const [loading, setLoading] = useState(false);

    const pageOption = [10, 25, 50, 100];
    
    const years = generateYearRange();
    const paymentMethods = getPaymentMethod();

    const navigate = useNavigate();
    const { permissions } = useUser();

    useEffect(() => {
        getStudentsData();
    },[filterData]);

    useEffect(() => {
        getData();
    },[]);

    const getStudentsData = async() => {
        setLoading(true);
        try {
            const studentsResponse = await apiService.get('/report/fee-payment', {
                params: {
                    ...filterData,
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                },
            });

            setData(studentsResponse?.data?.report);
            setTotalResults(studentsResponse?.data?.totalResults);
            setGrandTotalPaidAmount(studentsResponse?.data?.grandTotalPaidAmount);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const getData = async () => {
        try {
            const branchResponse = await apiService.get('/branch/list');

            setBranches(branchResponse?.data?.branchs);
        } catch (error) {
            console.error(error);
        }
    };

    const handleChangeSubmit = (e, value, name) => {
        setFilterData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    const handleChange = (name, value) => {
        setFilterData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    const CustomCategory = (categoryProp) => {
        const categories = categoryProp.value;
        
        return (
            <List>
                {categories?.map((category) => {
                    return <ListItem key={category._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                        {category?.category?.name}
                    </ListItem>
                })}
            </List>
        );
    }

    const CustomDate = (categoryProp) => {
        const categories = categoryProp.value;
        
        return (
            <List>
                {categories?.map((category) => {
                    if(category?.ots?.amount > 0 && category?.ots?.received) {
                        return <>
                            <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                                {new Date(category?.ots?.paidDate?.replace('Z', '')).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                            </ListItem>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                                        {new Date(fee.paidDate?.replace('Z', '')).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                                    </ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                                        {new Date(fee.paidDate?.replace('Z', '')).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                                    </ListItem>
                                }
                            })}
                        </>
                    }
                    else {

                        return <>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                                        {new Date(fee?.paidDate?.replace('Z', '')).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                                    </ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                                        {new Date(fee?.paidDate?.replace('Z', '')).toLocaleDateString('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' })}
                                    </ListItem>
                                }
                            })}
                        </>
                    }
                })}
            </List>
        );
    }

    const CustomAmount = (categoryProp) => {
        const categories = categoryProp.value;
        return (
            <List>
                {categories?.map((category) => {
                    if(category?.ots?.amount > 0 && category?.ots?.received) {
                        return <>
                            <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{category?.ots?.amount}</ListItem>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.value}</ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.value}</ListItem>
                                }
                            })}
                        </>
                    }
                    else {
                        return <>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.value}</ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.value}</ListItem>
                                }
                            })}
                        </>
                    }
                })}
            </List>
        );
    }

    const CustomPaymentMode = (categoryProp) => {
        const categories = categoryProp.value;
        return (
            <List>
                {categories?.map((category) => {
                    if(category?.ots?.amount > 0 && category?.ots?.received) {
                        return <>
                            <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{category?.ots?.paymentMethod}</ListItem>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.paymentMethod}</ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.paymentMethod}</ListItem>
                                }
                            })}
                        </>
                    }
                    else {
                        return <>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.paymentMethod}</ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.paymentMethod}</ListItem>
                                }
                            })}
                        </>
                    }
                })}
            </List>
        );
    }

    const CustomPaymentTransactionId = (categoryProp) => {
        const categories = categoryProp.value;
        return (
            <List>
                {categories?.map((category) => {
                    if(category?.ots?.amount > 0 && category?.ots?.received) {
                        return <>
                            <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{category?.ots?.transaction ?? '-' }</ListItem>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.transaction ?? '-'}</ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.transaction ?? '-'}</ListItem>
                                }
                            })}
                        </>
                    }
                    else {
                        return <>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.transaction ?? '-'}</ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={fee._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{fee.transaction ?? '-'}</ListItem>
                                }
                            })}
                        </>
                    }
                })}
            </List>
        );
    }

    const CustomTotalAmount = (categoryProp) => {
        const categories = categoryProp.value;
        let paidAmount = 0;

        {categories?.map((category) => {
            if(category?.ots?.amount > 0 && category?.ots?.received) {
                paidAmount += parseFloat(category?.ots?.amount);
                {category?.feeSplit.map((fee) => {
                    if(fee.received) {
                        paidAmount += parseFloat(fee.value);
                    }
                })}
                {category?.additionalCharge.map((fee) => {
                    if(fee.received) {
                        paidAmount += parseFloat(fee.value);
                    }
                })}
            }
            else {
                category?.feeSplit.map((fee) => {
                    if(fee.received) {
                        paidAmount += parseFloat(fee.value);
                    }
                });
                category?.additionalCharge.map((fee) => {
                    if(fee.received) {
                        paidAmount += parseFloat(fee.value);
                    }
                });
            }
        })}

        return paidAmount;
    }

    const CustomAcademicYear = (categoryProp) => {
        const categories = categoryProp.value;
        return (
            <List>
                {categories?.map((category) => {
                    return <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{category?.category?.year}</ListItem>
                })}
            </List>
        );
    }

    const CustomBranch = (categoryProp) => {
        const categories = categoryProp.value;
        return (
            <List>
                {categories?.map((category) => {
                    return <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{category?.branch}</ListItem>
                })}
            </List>
        );
    }

    const CustomLateByDay = (categoryProp) => {
        const categories = categoryProp.value;
        return (
            <List>
                {categories?.map((category) => {
                    if(category?.ots?.amount > 0 && category?.ots?.received) {
                        return <>
                            <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{Math.ceil((new Date(category?.ots?.dueDate) - new Date(category?.ots?.paidDate)) / (1000 * 60 * 60 * 24))}</ListItem>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{Math.ceil((new Date(fee.dueDate) - new Date(fee.paidDate)) / (1000 * 60 * 60 * 24))}</ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{Math.ceil((new Date(fee.dueDate) - new Date(fee.paidDate)) / (1000 * 60 * 60 * 24))}</ListItem>
                                }
                            })}
                        </>
                    }
                    else {
                        return <>
                            {category?.feeSplit.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{Math.ceil((new Date(fee.dueDate) - new Date(fee.paidDate)) / (1000 * 60 * 60 * 24))}</ListItem>
                                }
                            })}
                            {category?.additionalCharge.map((fee) => {
                                if(fee.received) {
                                    return <ListItem key={category?._id} sx={{ paddingTop: 0, paddingBottom: 0 }}>{Math.ceil((new Date(fee.dueDate) - new Date(fee.paidDate)) / (1000 * 60 * 60 * 24))}</ListItem>
                                }
                            })}
                        </>
                    }
                })}
            </List>
        );
    }

    const CustomBatch = (CategoryProp) => {
        const category = CategoryProp.value;
        const uniqueBatchesMap = new Map();

        category.forEach(category => {
            category?.batch?.forEach(batch => {
                if (!uniqueBatchesMap.has(batch.name)) {
                    uniqueBatchesMap.set(batch.name, batch.name);
                }
            });
        });

        const uniqueBatches = Array.from(uniqueBatchesMap.values());

        return(
            <List>
                {uniqueBatches?.map((batch, index) => {
                    return (
                        <ListItem sx={{ paddingTop: 0, paddingBottom: 0 }} key={index} title={batch}>{batch.substring(0, 15)}...</ListItem>
                    );
                })}
            </List>
        );
    }

    const navigateToStudent = (params) => {
        if(permissions.includes('updateStudent')) {
            navigate(`/dashboard/students/view?id=${params?.row?.student?._id}`);
        }
    }

    const exportReport = async () => {
        try {
            const response = await apiService.get('/export/report/fee-payment', {
                params: {
                    ...filterData,
                },
            });

            if(response?.data?.status === 'success') {
                
                window.open(`${apiUrl}${response?.data?.path}`, '_blank');
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    return (
        <div style={{ height: '75vh', width: '100%' }}>
            <Typography variant="h4" gutterBottom>
                FEE RECEIVED REPORT
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={4}>
                    <TextField
                        label="Name / Phone Number"
                        margin="normal"
                        name="name"
                        value={filterData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField
                        label="Branch"
                        select
                        value={filterData.branch}
                        onChange={(e) => handleChange('branch', e.target.value)}
                        fullWidth
                        name="branch"
                        margin="normal"
                        required
                        size='small'
                    >
                        <MenuItem value="">All</MenuItem>
                        <MenuItem value="Kozhikode">Kozhikode</MenuItem>
                        <MenuItem value="Kochi">Kochi</MenuItem>
                        <MenuItem value="Online">Online</MenuItem>
                    </TextField>
                </Grid>
                <Grid item xs={4}>
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        name="year"
                        required
                        options={years}
                        style={{ marginTop: 15 }}
                        getOptionLabel={(option) => option}  
                        value={years.find((option) => option === filterData.year) || null}
                        onChange={(e, value) => handleChangeSubmit(e, value, 'year')} 
                        renderInput={(params) => <TextField {...params} label="Academic Year" />}
                        size="small"
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 5 }}>
                <Grid item xs={4} style={{ marginTop: 20 }}>
                    <FormControl fullWidth size='small'>
                        <InputLabel id="PaymentMethod">Payment Method</InputLabel>
                        <Select
                            label="Payment Method"
                            value={filterData.paymentMethod}
                            onChange={(e) => handleChange('paymentMethod', e.target.value)}
                            fullWidth
                            name='paymentMethod'
                            size='small'
                        >
                            <MenuItem value="">All</MenuItem>
                            {paymentMethods?.map((method, index) => (
                                <MenuItem key={index} value={method}>{method}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} style={{ marginTop: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth>
                            <MobileDatePicker
                                label="Payment Date From"
                                value={filterData.paymentDateFrom ? dayjs(filterData?.paymentDateFrom) : null}
                                onChange={(date) => handleChange('paymentDateFrom', date)}
                                sx={{ marginTop: 1 }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                    textField: { size: 'small' },
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4} style={{ marginTop: 10 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} locale="en">
                        <FormControl className='gap-2 mb-8' fullWidth>
                            <MobileDatePicker
                                label="Payment Date To"
                                value={filterData.paymentDateTo ? dayjs(filterData?.paymentDateTo) : null}
                                onChange={(date) => handleChange('paymentDateTo', date)}
                                sx={{ marginTop: 1 }}
                                format="DD/MM/YYYY"
                                slotProps={{
                                    textField: { size: 'small' },
                                    actionBar: {
                                      actions: ['clear', 'cancel', 'accept'],
                                    },
                                }}
                            />
                        </FormControl>
                    </LocalizationProvider>
                </Grid>
            </Grid>

            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: 3 }}>
                <Grid item xs={4}>
                    <Card sx={{ padding: 2, backgroundColor: '#dde6ee' }}>
                        <Typography variant='h6'>
                            Total Paid Amount:
                            <br />
                            {grandTotalPaidAmount}
                        </Typography>
                    </Card>
                </Grid>
                <Grid item xs={8}>
                    {permissions.includes('exportFeeReceivedReport') && (
                        <Button variant="outlined" sx={{ float: 'right' }} title="Export" onClick={exportReport}><DownloadIcon /></Button>
                    )}
                </Grid>
            </Grid>

            {loading ? (
                <div style={{ textAlign: 'center' }}>
                    <CircularProgress style={{ margin: 'auto' }} />
                </div>

            ) : (
                <DataGridPro
                    getRowId={(row) => row._id}
                    rows={data}
                    onRowClick={navigateToStudent}
                    getRowHeight={() => 'auto'}
                    disableDensitySelector
                    columns={[
                        { field: 'student_name', headerName: 'Student', flex: 1, valueGetter: (params) =>  params?.row?.student?.firstName + ' ' + params?.row?.student?.lastName },
                        { field: 'student_phone', headerName: 'Phone', flex: 1, valueGetter: (params) =>  params?.row?.student?.phoneNumber },
                        { field: 'date', headerName: 'Date', flex: 1, renderCell: (params) => <CustomDate value={params?.row?.category} /> },
                        { field: 'amount', headerName: 'Amount', flex: 1, renderCell: (params) => <CustomAmount value={params?.row?.category} /> },
                        { field: 'paymentMethod', headerName: 'Payment Method', flex: 1, renderCell: (params) => <CustomPaymentMode value={params?.row?.category} /> },
                        { field: 'transactionId', headerName: 'Transaction Id', flex: 1, renderCell: (params) => <CustomPaymentTransactionId value={params?.row?.category} /> },
                        { field: 'totalAmount', headerName: 'Total Amount', flex: 1, renderCell: (params) => <CustomTotalAmount value={params?.row?.category} /> },
                        { field: 'course', headerName: 'Course', flex: 1, valueGetter: (params) => params?.row?.course?.name },
                        { field: 'category', headerName: 'Category', flex: 1, renderCell: (params) => <CustomCategory value={params?.row?.category} /> },
                        { field: 'year', headerName: 'Academic Year', flex: 1, renderCell: (params) => <CustomAcademicYear value={params?.row?.category} /> },
                        { field: 'branch', headerName: 'Branch', flex: 1, renderCell: (params) => <CustomBranch value={params?.row?.category} /> },
                        { field: 'lateByDays', headerName: 'Late By Days', flex: 1, renderCell: (params) => <CustomLateByDay value={params?.row?.category} /> },
                        { field: 'batch', headerName: 'Batch', flex: 1, renderCell: (params) => <CustomBatch value={params?.row?.category} /> },
                    ]}
                    pagination
                    paginationModel={paginationModel}
                    rowCount={totalResults}
                    paginationMode="server"
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={pageOption}
                />
            )}
        </div>
    );
}
